export const TXTWCL_If_you_continue_to_encounter_p_ELL = {
  "id": "TXTWCL_If_you_continue_to_encounter_p_ELL",
  "defaultMessage": "If you continue to encounter problems, please visit <a>here</a> for more details."
} as const;

export const TXTWCL_Please_refresh_your_browser_an_ELL = {
  "id": "TXTWCL_Please_refresh_your_browser_an_ELL",
  "defaultMessage": "Please refresh your browser and try again."
} as const;

export const TXTCLI_Enter_PIN = {
  "id": "TXTCLI_Enter_PIN",
  "defaultMessage": "Enter PIN"
} as const;

export const TXTWCL_Please_enter_your_PIN = {
  "id": "TXTWCL_Please_enter_your_PIN",
  "defaultMessage": "Please enter your PIN"
} as const;